import React from 'react';
import ReactECharts from 'echarts-for-react';
import './area-graph.css'
// Redux
import { connect } from "react-redux";
import { currentTheme } from "../../../redux/actions";


class AreaGraph extends React.Component {
    options = () => {
        const backgroundColor = window.getComputedStyle(document.documentElement).getPropertyValue('--input-bg-color')
        const txtColor = window.getComputedStyle(document.documentElement).getPropertyValue('--txt-color')
        return {
            backgroundColor,
            title: {
                show: false
            },
            textStyle: {
                color: txtColor
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                data: this.props.data.data.forEach(d => {
                    return d.label
                })
            },
            toolbox: {
                feature: {
                    saveAsImage: { show: false }
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: this.props.data.meses
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: 'Produtividade',
                    type: 'line',
                    stack: 'gStrategic',
                    areaStyle: {},
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.data.data[0].value,
                    itemStyle: {
                        normal: {
                            color: "#A3A0FB",
                        }
                    }
                },
                {
                    name: 'Movimentações',
                    type: 'line',
                    stack: 'gStrategic',
                    areaStyle: {},
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.data.data[1].value,
                    itemStyle: {
                        normal: {
                            color: "#57D9FE"
                        }
                    }

                },
                // {
                //     name: 'Pants',
                //     type: 'line',
                //     stack: 'gStrategic',
                //     areaStyle: {},
                //     emphasis: {
                //         focus: 'series'
                //     },
                //     data: this.props.data.data[2].value,
                //     itemStyle: {
                //         normal: {
                //             color: "#FFFC00"
                //         }
                //     }
                // },
            ]
        }
    }
    render() {
        return (
            <div className='area-graph-container'>
                <div className='area-graph-header'>
                    <span>Gráfico Estratégico</span>
                </div>
                <div style={{padding: '0px 8px'}}>

                <ReactECharts
                    option={this.options()}
                    notMerge={true}
                    lazyUpdate={true}
                    theme={this.props.theme === "dark" ? 'dark' : ''}

                />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        theme: state.theme
    };
};

const mapDispatchToProps = dispatch => {
    return {
        currentTheme: data => dispatch(currentTheme(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AreaGraph)





